import { useExperimentBucket as useCarvanaExperimentBucket } from '@carvana/experiment';
import { Experiments } from '~/contracts/common';

export default function useExperimentBucket(
  experimentName: keyof Experiments
): string {
  return useCarvanaExperimentBucket(experimentName);
}
